import { render } from "./ConsultationHistoryAllergyTab.vue?vue&type=template&id=b1cc8196&scoped=true"
import script from "./ConsultationHistoryAllergyTab.vue?vue&type=script&lang=js"
export * from "./ConsultationHistoryAllergyTab.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./ConsultationHistoryAllergyTab.vue?vue&type=style&index=1&id=b1cc8196&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1cc8196"]])

export default __exports__